module.exports = require("./gu-IN");